/**
 * Flatten a hierarchical tree into a virtual-list-compatible array,
 * respecting which nodes are currently collapsed.
 *
 * @param {Object[]} nodes - the (already-filtered) tree
 * @param {Set<string>} collapsedNodes - keys of collapsed nodes
 * @param {number} [depth=0] - current recursion depth
 * @returns {{ node: Object, depth: number, hasChildren: boolean, collapseKey: string }[]}
 */
export const flattenVisibleTree = (nodes, collapsedNodes, depth = 0) => {
  const rows = [];

  for (const node of nodes) {
    const collapseKey = node.id || node._id || node.name;
    const hasChildren = node.children?.length > 0;
    const isCollapsed = collapsedNodes.has(collapseKey);

    rows.push({ node, depth, hasChildren, collapseKey });

    if (hasChildren && !isCollapsed) {
      const childRows = flattenVisibleTree(
        node.children,
        collapsedNodes,
        depth + 1,
      );
      for (const row of childRows) rows.push(row);
    }
  }

  return rows;
};
